<div class="login-loader">
  <div class="login-loader-inner">
    <div class="login-heading"><span class="sLoader"></span></div>
    <div class="login-text"><span class="sLoader"></span></div>
    <form>
      <div class="login-form-item">
        <div class="lable"><span class="sLoader"></span></div>
        <div class="input-area"><span class="sLoader"></span></div>
      </div>
      <div class="login-form-item">
        <div class="lable"><span class="sLoader"></span></div>
        <div class="input-area">
          <span class="sLoader"></span>
          <div class="forget-password"></div>
        </div>
      </div>
      <div class="login-form-button"><span class="sLoader"></span></div>
    </form>
  </div>
</div>
